"use client"

import {
  Carousel,
  CarouselContent,
  CarouselItem
} from "@/components/ui/carousel"
import type { BannerDTO } from "@/domain/cms/contracts"

import { BannerCard } from "./BannerCard"
import { PromoDots } from "./PromoDots"
import { COMPACT_BANNER_SIZES, FEATURED_BANNER_SIZES } from "./slides"

export function PromoFeaturedRail({ banners }: { banners: BannerDTO[] }) {
  const hero = banners.find((banner) => banner.variant === "featured")
  if (!hero) {
    return null
  }

  const rest = banners.filter((banner) => banner.id !== hero.id)

  return (
    <div className="flex items-start gap-4">
      <BannerCard
        banner={hero}
        featured
        priority
        sizes={FEATURED_BANNER_SIZES}
        className="h-[308px] w-[428px] shrink-0"
      />
      {rest.length > 0 && (
        <Carousel
          className="min-w-0 flex-1"
          opts={{ align: "start", loop: true }}
        >
          <CarouselContent className="-ml-4">
            {rest.map((banner) => (
              <CarouselItem
                key={banner.id}
                className="basis-full pl-4 xl:basis-1/3"
              >
                <BannerCard
                  banner={banner}
                  sizes={COMPACT_BANNER_SIZES}
                  className="h-[288px]"
                  loading={banner.imageUrl === hero.imageUrl ? "eager" : "lazy"}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <PromoDots count={rest.length} className="mt-2.5 mb-0" />
        </Carousel>
      )}
    </div>
  )
}
